import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import { type CreditCardItemFormSchema } from '@webapp/modules/accounts-payable/components/CreditCardItemForm'
import { type CreditCardAccount } from '@webapp/modules/accounts-payable/entities/CreditCardAccount'
import { type CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import messages from './messages'
import { useMutateCreateCreditCardItem } from '../../models'

export interface IUseCreateCreditCardItemFormPresenterParams {
  account: CreditCardAccount
  onSuccess: (item: CreditCardItem) => void
}

export const useCreateCreditCardItemFormPresenter = ({
  account,
  onSuccess,
}: IUseCreateCreditCardItemFormPresenterParams) => {
  const intl = useProcurifyIntl()
  const { createCreditCardItem, isCreating } = useMutateCreateCreditCardItem()

  const handleSubmit = async (schema: CreditCardItemFormSchema) => {
    try {
      const item = await createCreditCardItem({
        creditcardId: account.id,
        schema,
      })

      toast.success({
        title: intl.formatMessage(messages.successTitle),
        children: intl.formatMessage(messages.successMessage),
      })

      onSuccess(item)
    } catch (error) {
      toast.error({
        title: intl.formatMessage(messages.errorTitle),
        children:
          getMessageFromError(error) ??
          intl.formatMessage(messages.genericErrorMessage),
      })
    }
  }

  return {
    states: {
      isCreating,
    },
    methods: {
      onSubmit: handleSubmit,
    },
  }
}
